import * as SubscriptionAction from "./SubscriptionAction";

export default function subscriptionReducer(state = {}, action) {
    switch (action.type) {
        case SubscriptionAction.REQUEST_ALL_SUBSCRIPTION_FOLDERS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    subscriptionFolders: {
                        ...action.payload
                    }
                };
            }
        case SubscriptionAction.REQUEST_ALL_SUBSCRIPTIONS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    allSubscriptions: {
                        ...action.payload
                    }
                };
            }
        case SubscriptionAction.REQUEST_USER_SUBSCRIPTIONS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    userSubscriptions: {
                        ...action.payload
                    }
                };
            }
        case SubscriptionAction.REQUEST_USER_UNASSIGNED_SUBSCRIPTION_TYPES_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    userUnassignedSubscriptionTypes: {
                        ...action.payload
                    }
                };
            }
        case SubscriptionAction.REQUEST_SUBSCRIPTION_USERS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    subscriptionUsers: {
                        ...action.payload
                    }
                };
            }
        case SubscriptionAction.CREATE_SUBSCRIPTION_FINISHED:
        case SubscriptionAction.UPDATE_SUBSCRIPTION_FINISHED:
        case SubscriptionAction.DELETE_SUBSCRIPTION_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    ...action.payload
                };
            }
        case SubscriptionAction.REQUEST_USER_DATE_RANGES_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    dateRanges: {
                        ...action.payload
                    }
                };
            }
        case SubscriptionAction.REQUEST_ALL_USER_DATE_RANGES_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    allUserDateRanges: {
                        ...action.payload
                    }
                };
            }
        case SubscriptionAction.REQUEST_SUBSCRIPTION_CONTACTS_FINISHED:
            // TODO: handle errors
            if (action.payload.errors) {
                return {
                    ...state
                };
            } else {
                return {
                    ...state,
                    contacts: {
                        ...action.payload
                    }
                };
            }
        default:
            return state;
    }
}
